<template>
  <div class="answer-box" ref="answerbox">
    <question-type :data="question"></question-type>
    <!-- <check-box v-show="question.questionType === 'MULTI_CHOICE'" :data="question"></check-box> -->
    <div class="footer">
      <span :class="['up-question', disableUp && 'disable']" @click="$store.dispatch('questions/selectQuestion', 'up')">上一题</span>
      <!-- <span class="analysis" @click="openAnalysis">查看解析</span> -->
      <span :class="['down-question', (disableDown || questionNum <= 1) && 'disable']" @click="$store.dispatch('questions/selectQuestion', 'down')">下一题</span>
    </div>
    <Score v-if="isShowScore"></Score>
  </div>
</template>

<script>
  import QuestionType from '../../components/questions/questionType';
  import Score from '../../components/questions/score';
  export default {
    name: 'answerPage',
    components: {
      QuestionType,
      Score
    },
    data() {
      return {
        params: this.$route.query
      }
    },
    computed: {
      question() {
        return this.$store.state.questions.showQuestion;
      },
      disableUp() {
        return this.$store.state.questions.disableUp;
      },
      disableDown() {
        return this.$store.state.questions.disableDown;
      },
      finished() {
        return this.$store.state.questions.finished;
      },
      isShowScore() {
        return this.$store.state.questions.isShowScore;
      },
      questionNum() {
        return this.$store.state.questions.questionNum;
      }
    },
    created() {
      console.log('--------------------------this.params------------', this.params)
      this.$store.dispatch('questions/getQuestion', this.params);
    },
    mounted() {
       console.log(this.$refs.answerbox.getBoundingClientRect().left, this.questionNum)
    },
    methods: {
      openAnalysis() {
        if(this.finished === 1)
        this.$store.dispatch('questions/findAnalysis');
      }
    }
  }
</script>
<style scoped lang="scss" src="./scss/answerPage.scss"></style>



// WEBPACK FOOTER //
// src/views/questions/answerPage.vue